/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CoupangUploadFilesVo } from './CoupangUploadFilesVo';
import {
    CoupangUploadFilesVoFromJSON,
    CoupangUploadFilesVoFromJSONTyped,
    CoupangUploadFilesVoToJSON,
    CoupangUploadFilesVoToJSONTyped,
} from './CoupangUploadFilesVo';

/**
 * 
 * @export
 * @interface ResponseCoupangUploadFilesVo
 */
export interface ResponseCoupangUploadFilesVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCoupangUploadFilesVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCoupangUploadFilesVo
     */
    message?: string;
    /**
     * 
     * @type {CoupangUploadFilesVo}
     * @memberof ResponseCoupangUploadFilesVo
     */
    data?: CoupangUploadFilesVo;
}

/**
 * Check if a given object implements the ResponseCoupangUploadFilesVo interface.
 */
export function instanceOfResponseCoupangUploadFilesVo(value: object): value is ResponseCoupangUploadFilesVo {
    return true;
}

export function ResponseCoupangUploadFilesVoFromJSON(json: any): ResponseCoupangUploadFilesVo {
    return ResponseCoupangUploadFilesVoFromJSONTyped(json, false);
}

export function ResponseCoupangUploadFilesVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCoupangUploadFilesVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CoupangUploadFilesVoFromJSON(json['data']),
    };
}

export function ResponseCoupangUploadFilesVoToJSON(json: any): ResponseCoupangUploadFilesVo {
    return ResponseCoupangUploadFilesVoToJSONTyped(json, false);
}

export function ResponseCoupangUploadFilesVoToJSONTyped(value?: ResponseCoupangUploadFilesVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CoupangUploadFilesVoToJSON(value['data']),
    };
}

